import { loadingAtom } from '@states/uiAtoms';
import { useSetAtom } from 'jotai';

function useLoading() {
  const setLoading = useSetAtom(loadingAtom);
  const startLoading = () => {
    setLoading(true);
  };
  const stopLoading = () => {
    setLoading(false);
  };
  return {
    startLoading, stopLoading,
  };
}

export default useLoading;
